import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AuditionConfirmation = () => {
  return (
    <div className="text-center space-y-6 py-12">
      <div className="mx-auto w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
        <CheckCircle className="h-10 w-10 text-primary" />
      </div>
      
      <div className="space-y-2">
        <h2 className="text-2xl font-bold">Audition Submitted</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Thank you for completing the Lost Strings vetting process.
          Our team will review your submission and be in touch within 5–7 business days.
        </p>
      </div>

      <div className="bg-muted/50 rounded-lg p-4 max-w-sm mx-auto border">
        <p className="text-sm text-muted-foreground">
          <strong>What happens next?</strong>
        </p>
        <ul className="text-sm text-muted-foreground mt-2 space-y-1 text-left">
          <li>• A regional manager will review your recordings</li>
          <li>• You'll receive a tier classification (A, B, or C)</li>
          <li>• Approved musicians are added to the active roster</li>
        </ul>
      </div>

      <Button variant="outline" onClick={() => window.location.href = "/"}>
        Return to Home
      </Button>
    </div>
  );
};
